<template>
  <div class="container bg-light">
    <div class="alert alert-primary" role="alert">
      <p>You need to <b>Register</b> before...</p>
    </div>

    <div class="row">
      <div class="col-md-4 order-md-2 mb-4">
        <h4 class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-muted">You are Subscribing to</span>
          <span class="badge badge-primary badge-pill">{{
            plan.metadata.product_name
          }}</span>
        </h4>
        <ul class="list-group mb-3">
          <li
            class="list-group-item d-flex justify-content-between lh-condensed"
          >
            <div>
              <h6 class="my-0">Product name:</h6>
              <br />
              <h6>Description:</h6>
              <small class="text-muted"> {{ plan.metadata.description }}</small>
            </div>
            <span class="text-muted">{{ plan.metadata.product_name }}</span>
          </li>

          <li class="list-group-item d-flex justify-content-between">
            <span>Total (USD)</span>
            <strong>{{ dolar(plan.amount) }}.00</strong>
          </li>
        </ul>

        <input
          class="btn btn-dark btn-lg btn-block"
          disabled
          type="submit"
          value="Continue to checkout"
        />
      </div>
      <div class="col-md-8 order-md-1">
        <h4 class="mb-3">Billing address</h4>
        <form>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="firstName">First name</label>
              <input
                type="text"
                class="form-control"
                id="firstName"
                placeholder=""
                value=""
                required
              />
            </div>
            <div class="col-md-6 mb-3">
              <label for="lastName">Last name</label>
              <input
                type="text"
                class="form-control"
                id="lastName"
                placeholder=""
                value=""
                required
              />
            </div>
          </div>

          <div class="mb-3">
            <label for="email">Email <span class="text-muted"></span></label>
            <input
              type="email"
              class="form-control"
              id="email"
              placeholder="you@example.com"
              required
            />
          </div>

          <div class="mb-3">
            <label for="address">Address</label>
            <input
              type="text"
              class="form-control"
              id="address"
              placeholder="1234 Main St"
              required
            />
          </div>

          <div class="row">
            <div class="col-md-5 mb-3">
              <label for="country">Country</label>
              <select class="custom-select d-block w-100" id="country" required>
                <option value="">Choose...</option>
                <option>United States</option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label for="state">State</label>
              <select class="custom-select d-block w-100" id="state" required>
                <option value="">Choose...</option>
                <option>North Carolina</option>
              </select>
            </div>
            <div class="col-md-3 mb-3">
              <label for="zip">Zip</label>
              <input
                type="text"
                class="form-control"
                id="zip"
                placeholder=""
                required
              />
            </div>
          </div>

          <hr class="mb-4" />
          <button class="btn btn-info" type="submit">Register</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      plan: this.$route.params.plan
    };
  },

  created() {},

  methods: {
    dolar(value) {
      return value / 100;
    }
  }
};
</script>
